import React from 'react';
import {
  AfterSubmitFunc,
  AsyncMultiSelectDropdown,
  FormTemplate,
  LoadingAnimation,
  TextInput
} from 'ui-builder';
import {
  CreateDetailsSetFieldRequest,
  DetailsFieldsSet,
  ProjectDetailsField,
  ProjectType,
  TeamPermission,
  useDetailsFieldsSetsService,
  useProjectDetailsFieldsService
} from 'nekst-api';

import { useDataLoaderNew } from 'data-loader';
import ContractExampleFileUploader from './ContractExampleFileUploader';
import { useAuthorizationChecker } from 'authorization-scope';

function DetailsFieldsMultiDropdown(props: {
  projectType: ProjectType,
}) {
  const detailsFieldsService = useProjectDetailsFieldsService();

  return (
    <AsyncMultiSelectDropdown
      loadOptionsFunc={async () => {
        return (await detailsFieldsService.getFields(props.projectType))
          .map((field) => ({
            value: field.id,
            label: field.name
          }));
      }}
      source="includedFieldsIds"
      label="Include Boxes"
    />
  );
}

export default function CreateDetailsFieldsSetForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
    projectType: ProjectType
  }
) {
  const setsService = useDetailsFieldsSetsService();

  const detailsFieldsService = useProjectDetailsFieldsService();

  const { isGranted } = useAuthorizationChecker();

  const { data: fields } = useDataLoaderNew<ProjectDetailsField[]>(
    () => detailsFieldsService.getFields(props.projectType),
  );

  if (fields) {
    return (
      <FormTemplate<CreateDetailsSetFieldRequest, DetailsFieldsSet>
        title="Create Detail Box Set"
        submitFormFunc={async (data) => {
          return setsService.createSet(data);
        }}
        afterSubmitFunc={props.afterSubmitFunc}
        initialData={{
          projectType: props.projectType,
          includedFieldsIds: fields.map((item) => item.id),
        }}
        validationSchema={{
          name: {
            type: 'string',
            constraints: {
              required: true,
              maxLength: 40,
            },
          },
          includedFieldsIds: {
            type: 'array',
            constraints: {
              required: true,
            },
          },
          contractDocumentValidationFileId: {
            type: 'int',
            constraints: {
              required: {
                value: true,
                when: {
                  contractDocumentExampleFileId: {
                    notEmpty: true,
                  }
                }
              }
            }
          }
        }}
      >
        <TextInput source="name" label="Name" />
        <DetailsFieldsMultiDropdown projectType={props.projectType} />
        {isGranted(TeamPermission.MANAGE_AI_TRAINING_DATA) && (
          <ContractExampleFileUploader />
        )}
      </FormTemplate>
    );
  } else {
    return (<LoadingAnimation />);
  }
}
